import { render, staticRenderFns } from "./viewFormulaFir.vue?vue&type=template&id=1496b2f6&scoped=true&"
import script from "./viewFormulaFir.vue?vue&type=script&lang=js&"
export * from "./viewFormulaFir.vue?vue&type=script&lang=js&"
import style0 from "./viewFormulaFir.vue?vue&type=style&index=0&id=1496b2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1496b2f6",
  null
  
)

export default component.exports